import { Component, inject } from '@angular/core';
import { ActivityToolService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  ActivityToolCreateDto,
  ActivityToolDto,
  ActivityToolExcelDownloadDto,
  ActivityToolUpdateDto,
} from '../proxy/controlling/dtos/activity-tool';
import { ACTIVITYTOOL_CONFIG, ACTIVITYTOOL_FIELDS } from './activity-tool.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-activity-tool',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, ActivityToolService, ConfirmationService],
  templateUrl: './activity-tool.html',
  styleUrl: './activity-tool.scss',
})
export class ActivityTool extends BaseCrudComponent<
  ActivityToolDto,
  ActivityToolCreateDto,
  ActivityToolUpdateDto,
  ActivityToolExcelDownloadDto
> {
  service = inject(ActivityToolService);
  config = ACTIVITYTOOL_CONFIG;
  fields = ACTIVITYTOOL_FIELDS;

  protected prepareUpdateDto(data: any, selected: ActivityToolDto): ActivityToolUpdateDto {
    return {
      name: data.name,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'ActivityTool';
  }
}
